import { createSlice, EntityId } from '@reduxjs/toolkit';

export interface CategoryInterface {
  [key: string]: {
    id: number;
    name: string;
    url: string;
    parent_id: number | null;
    subcategories: number[];
  }
}

export interface initialInterface {
  error: string | null;
  loading: boolean;
  entities: CategoryInterface | null;
  ids: EntityId[];
}

const initialState: initialInterface = {
  error: null,
  loading: false,
  entities: null,
  ids: []
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setIds(state, action) {
      state.ids = action.payload;
    },
    setCategories(state, action) {
      state.entities = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    }
  }
});

export const {
  setLoading,
  setError,
  setIds,
  setCategories
} = categoriesSlice.actions;

export default categoriesSlice.reducer;
